import { logError } from '~publish/legacy/utils/logError'

import type { ImportItem, ImportSession, SerializedImportItem } from './types'

const STORAGE_KEY = 'buffer:migration-session'
const SESSION_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

export function saveSession(session: ImportSession): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
  } catch (error) {
    logError(error, { context: 'saveImportSession' })
  }
}

export function loadSession(): ImportSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const session: ImportSession = JSON.parse(raw)

    if (
      !session.id ||
      !session.source ||
      !session.startedAt ||
      !session.items
    ) {
      clearSession()
      return null
    }

    const age = Date.now() - new Date(session.startedAt).getTime()
    if (age > SESSION_MAX_AGE_MS) {
      clearSession()
      return null
    }

    return session
  } catch {
    clearSession()
    return null
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // silently ignore
  }
}

export function serializeItems(items: ImportItem[]): SerializedImportItem[] {
  return items.map((item) => ({
    ...item,
    post: {
      ...item.post,
      scheduledTime: item.post.scheduledTime?.toISOString(),
    },
  }))
}

export function deserializeItems(items: SerializedImportItem[]): ImportItem[] {
  return items.map((item) => ({
    ...item,
    post: {
      ...item.post,
      scheduledTime: item.post.scheduledTime
        ? new Date(item.post.scheduledTime)
        : undefined,
    },
  }))
}
